export const opportunities = [
  {
    title: "All Types",
    type: "",
  },
  {
    title: "Company Opportunity",
    type: "diverse_company",
  },
  {
    title: "Capital/Funding Opportunity",
    type: "funding",
  },
  {
    title: "Projects Opportunity",
    type: "project",
  },
  {
    title: "Board of Directors Opportunity",
    type: "board_of_directors",
  },
  {
    title: "Careers-Executive Opportunity",
    type: "careers_executive",
  },
  {
    title: "Careers-Professional Opportunity",
    type: "careers_professional",
  },
  {
    title: "Mentors Opportunity",
    type: "mentoring",
  },

  {
    title: "Sponsors Opportunity",
    type: "sponsorship",
  },
]
